/* recently-viewed.js — tracks viewed products (localStorage) and renders the
   recently-viewed block by fetching product cards. Framework-free, deferred. */
(function () {
  'use strict';
  var KEY = 'pu:recently-viewed';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
  }

  function track() {
    var marker = document.querySelector('[data-current-product]');
    if (!marker) return null;
    var handle = marker.getAttribute('data-handle');
    if (!handle) return null;
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(list);
    return handle;
  }

  function render(currentHandle) {
    var block = document.querySelector('[data-recently-viewed]');
    if (!block) return;
    var grid = block.querySelector('[data-recently-viewed-grid]');
    var row = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--product-cards-desktop'), 10);
    if (!row || row < 1) row = 5;
    var requested = parseInt(block.getAttribute('data-limit'), 10);
    var limit = requested > 0 ? requested : row;
    if (limit < row) limit = row;
    var handles = read().filter(function (h) { return h !== currentHandle; }).slice(0, limit);
    if (!handles.length) return;

    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '?section_id=product-card-ajax')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })
    ).then(function (parts) {
      var html = parts.join('').trim();
      if (!html) return;
      grid.innerHTML = html;
      var listId = block.getAttribute('data-item-list-id') || 'recently_viewed';
      var listName = block.getAttribute('data-item-list-name') || '';
      grid.querySelectorAll('.product-card').forEach(function (card) {
        card.setAttribute('data-item-list-id', listId);
        if (listName) card.setAttribute('data-item-list-name', listName);
      });
      var cardSizes = block.getAttribute('data-card-sizes');
      if (cardSizes) {
        grid.querySelectorAll('img[sizes]').forEach(function (img) {
          img.setAttribute('sizes', cardSizes);
        });
      }
      block.hidden = false;
    });
  }

  function init() {
    var current = track();
    render(current);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
